import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import * as ActionEvents from '../actions/PersonRelationshipTypes.Actions';
import { PersonRelationshipTypeState, PersonRelationshipTypeUnloadState } from '../states/PersonRelationshipTypeState';
import { RelationShipTypeViewModel } from '../../models/Entities/Person/RelationshipType/RelationshipTypeModels';

export type KnownAction =
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteFailureAction;

export const PersonRelationshipTypesReducer: Reducer<PersonRelationshipTypeState> = (
    state: PersonRelationshipTypeState | undefined,
    incomingAction: Action
): PersonRelationshipTypeState => {
    if (state === undefined) {
        return PersonRelationshipTypeUnloadState as PersonRelationshipTypeState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_REQUEST:
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: undefined,
                failOnLoadingAll: false,
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_SUCCESS: {
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                list: action.payload,
                error: undefined
            };
        }
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };

        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_REQUEST:
            return {
                ...state,
                isLoadingOne: true,
                successLoadingOne: undefined,
                failOnLoadingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_SUCCESS: {
            const filtered = state.list.filter((item: RelationShipTypeViewModel) => item.id !== action.payload.id);
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                list: [...filtered, action.payload],
                error: undefined
            };
        }
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE:
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_REQUEST:
            return {
                ...state,
                isAddingNewOne: true,
                successAddingNewOne: undefined,
                failOnAddingNewOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_SUCCESS: {
            const createdList = state.list.some((item: RelationShipTypeViewModel) => item.id === action.payload.id)
                ? state.list.map((item: RelationShipTypeViewModel) => (item.id === action.payload.id ? action.payload : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                lastCreated: action.payload,
                list: createdList,
                error: undefined
            };
        }
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE:
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_REQUEST:
            return {
                ...state,
                isUpdatingOne: true,
                successUpdatingOne: undefined,
                failOnUpdatingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_SUCCESS: {
            const updatedList = state.list.some((item: RelationShipTypeViewModel) => item.id === action.payload.id)
                ? state.list.map((item: RelationShipTypeViewModel) => (item.id === action.payload.id ? { ...item, ...action.payload } : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                list: updatedList,
                error: undefined
            };
        }
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE:
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_REQUEST:
            return {
                ...state,
                isDeletingOne: true,
                successDeletingOne: undefined,
                failOnDeletingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                list: state.list.filter((item: RelationShipTypeViewModel) => item.id !== action.id),
                error: undefined
            };
        case ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: action.error
            };
        default:
            return state;
    }
};
